/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from "react"
import PropTypes from "prop-types"
import { useFormContext } from "react-hook-form"
import { ErrorMessage } from '@hookform/error-message';
import { jsx } from "theme-ui"
import {
  FieldWrapperStyles,
  InputStyles,
  LabelStyles,
} from "./FormElementStyles"
import Tooltip from "./Tooltip"

const TextArea = ({
  id,
  name,
  type,
  label,
  placeholder,
  value,
  required,
  fullWidth,
  overrideStyles,
}) => {
  const { register, errors } = useFormContext()
  const errorHighlight = Object.keys(errors).length === 0 ? null : { borderColor: "inputError", outline: "2px solid", outlineColor: "inputError", }
  return (
    <div
      sx={{
        width: fullWidth ? "100%" : "50%",
        ...FieldWrapperStyles,
        ...overrideStyles,
      }}
    >
      {label && (
        <label
          sx={{
            ...LabelStyles,
            display: "inline-block",
          }}
          htmlFor={id || name}
        >
          {label}
        </label>
      )}
      <textarea
        type={type}
        id={id || name}
        name={name}
        placeholder={placeholder}
        defaultValue={value}
        rows="10"
        ref={register({
          required: {
            value: required,
            message: `This field is required.`,
          },
        })}
        sx={{
          ...InputStyles,
          height: "auto",
          ...errorHighlight
        }}
      />


        {errors && (
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <Tooltip color='danger'>{message}</Tooltip>}
          />
        )}
    </div>
  )
}

TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  overrideStyles: PropTypes.shape({}),
}
TextArea.defaultProps = {
  type: "text",
  placeholder: "",
  required: false,
  value: "",
  id: null,
  fullWidth: false,
  overrideStyles: null,
}

export default TextArea
